// frontend/src/components/OrderLookup.js
import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE } from 'config';

export default function OrderLookup({ onResult, onNoMatch, tenantId }) {
  const [orderNumber, setOrderNumber] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');

  function normalizeOrderInput(raw) {
    if (!raw) return '';
    const cleaned = raw.trim().replace(/^#/, '');
    return cleaned.toUpperCase();
  }

  async function lookup() {
    setLoading(true);
    setMsg('');
    try {
      const hasOrder = !!orderNumber.trim();
      const hasEmail = !!email.trim();

      if (!hasOrder && !hasEmail) {
        setMsg('Enter an order number or email to lookup.');
        setLoading(false);
        return;
      }

      const params = new URLSearchParams();
      if (hasOrder) params.append('order_number', normalizeOrderInput(orderNumber));
      if (hasEmail) params.append('email', email.trim());
      if (tenantId) params.append('tenantId', tenantId);

      const url = `${(API_BASE || '').replace(/\/$/, '')}/shopify/lookup?${params.toString()}`;

      const res = await axios.get(url, {
        headers: { 'Accept': 'application/json' },
        timeout: 15000,
      });

      const data = res.data || {};

      const hasSingleOrder = data.found && (data.order_number || data.order || data.line_items);
      const hasEmailOrders = Array.isArray(data.orders) && data.orders.length > 0;

      if (hasSingleOrder) {
        onResult(data);
      } else if (hasEmailOrders) {
        onResult({ orders: data.orders, found: data.found });
      } else {
        onNoMatch(data);
      }
    } catch (err) {
      const status = err?.response?.status;
      if (status === 404) {
        setMsg('No order found — try #1001, #1002 or #DEMO123.');
      } else {
        setMsg('Lookup failed — try again or continue to chat.');
      }
      console.warn('Order lookup failed', err?.response || err);
      onNoMatch({ error: (err?.response?.data || err?.message) });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="order-lookup mb-3">
      <div className="text-sm text-gray-700 mb-2">Quick order lookup — reduce support calls.</div>

      <div className="flex gap-2 mb-2">
        <input
          value={orderNumber}
          onChange={(e) => setOrderNumber(e.target.value)}
          placeholder="Order # (e.g., #1001 or DEMO123)"
          className="border p-2 rounded flex-grow"
        />
        <button onClick={lookup} disabled={loading} className="px-3 py-2 bg-indigo-600 text-white rounded">
          {loading ? 'Checking…' : 'Check'}
        </button>
      </div>

      <div className="text-xs text-gray-500 mb-2">Or enter email to find recent orders.</div>

      <div className="flex gap-2">
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email on order (optional)"
          className="border p-2 rounded flex-grow"
        />
        <button onClick={lookup} disabled={loading || (!email && !orderNumber)} className="px-3 py-2 border rounded">
          {loading ? 'Checking…' : 'Lookup'}
        </button>
      </div>

      {msg && <div className="text-xs text-red-600 mt-2">{msg}</div>}
      {/* TIP REMOVED — now shown only in RagDemo.js */}
    </div>
  );
}